/**
 * DIE AUTOMATISCHE VERDICHTUNGS-ZUSAMMENFASSUNG IM CHAT.
 *
 * Wenn einer Sitzung der Kontext ausgeht, schreibt Claude Code eine Nutzer-Nachricht
 * ("This session is being continued from a previous conversation …") mit einer langen
 * Zusammenfassung, einer Zeile "… read the full transcript at: /home/…/<id>.jsonl" und
 * einer Anweisung an das Modell. Sie stand im Chat wie eine normale Nachricht des
 * Nutzers, mit rohem Dateipfad.
 *
 * Rafael, 03.10.2026 16:35 UTC, Wahl a ("Zusammenfassung eingeklappt"): fuer ALLE als
 * eingeklappter Block "Zusammenfassung des bisherigen Gespraechs"; der rohe
 * Transkript-Pfad faellt fuer Nicht-Admins weg.
 *
 * Erkennung wie `audit.ts` (Bereinigung der Eingabe-Historie): am festen Anfangstext.
 * Server und Oberflaeche nutzen dieselbe Funktion — der Server markiert und kuerzt,
 * die Oberflaeche erkennt auch live gestreamte Nachrichten, die nie ueber den Server-
 * Weg kamen.
 */
export const VERDICHTUNG_ANFANG = 'This session is being continued from a previous conversation';

export function istVerdichtungsZusammenfassung(text: unknown): boolean {
  return typeof text === 'string' && text.trimStart().startsWith(VERDICHTUNG_ANFANG);
}

/** Die Zeile mit dem Transkript-Pfad ("… read the full transcript at: <pfad>"). */
const TRANSKRIPT_ZEILE = /^.*read the full transcript at:.*(?:\r?\n|$)/gim;

/** Entfernt den rohen Transkript-Pfad. Alles andere bleibt Wort fuer Wort stehen. */
export function ohneTranskriptPfad(text: string): string {
  return text.replace(TRANSKRIPT_ZEILE, '').replace(/\n{3,}/g, '\n\n');
}
